import React from 'react';
import { IconProps } from '../types';
const MinecraftGrayCandle: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="1" width="1" height="1" fill="rgba(51, 48, 101, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(51, 48, 101, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(33, 32, 52, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(114, 137, 150, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(114, 137, 150, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(114, 137, 150, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(114, 137, 150, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(114, 137, 150, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(108, 123, 131, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(98, 113, 115, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(82, 97, 98, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(74, 89, 90, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(59, 71, 72, 255)" />
</svg>);
export default MinecraftGrayCandle;